(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];




    function stateConfig($stateProvider) {

        $stateProvider
        .state('questionnaire-group', {
            parent: 'admin',
            url: '/questionnaire-group?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'abcQualityMatchApp.questionnaireGroup.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/questionnaire-group/questionnaire-groups.html',
                    controller: 'QuestionnaireGroupController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('questionnaireGroup');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('questionnaire-group-detail', {
            parent: 'questionnaire-group',
            url: '/questionnaire-group/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'abcQualityMatchApp.questionnaireGroup.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/questionnaire-group/questionnaire-group-detail.html',
                    controller: 'QuestionnaireGroupDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('questionnaireGroup');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'QuestionnaireGroup', function($stateParams, QuestionnaireGroup) {
                    return QuestionnaireGroup.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'questionnaire-group',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('questionnaire-group-detail.edit', {
            parent: 'questionnaire-group-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/questionnaire-group/questionnaire-group-dialog.html',
                    controller: 'QuestionnaireGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['QuestionnaireGroup', function(QuestionnaireGroup) {
                            return QuestionnaireGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('questionnaire-group.new', {
            parent: 'questionnaire-group',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/questionnaire-group/questionnaire-group-dialog.html',
                    controller: 'QuestionnaireGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null,
                                questionnaires: [],
                                companies:[]
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('questionnaire-group', null, { reload: 'questionnaire-group' });
                }, function() {
                    $state.go('questionnaire-group');
                });
            }]
        })
        .state('questionnaire-group.edit', {
            parent: 'questionnaire-group',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/questionnaire-group/questionnaire-group-dialog.html',
                    controller: 'QuestionnaireGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['QuestionnaireGroup', function(QuestionnaireGroup) {
                            return QuestionnaireGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('questionnaire-group', null, { reload: 'questionnaire-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('questionnaire-group.delete', {
            parent: 'questionnaire-group',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/questionnaire-group/questionnaire-group-delete-dialog.html',
                    controller: 'QuestionnaireGroupDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['QuestionnaireGroup', function(QuestionnaireGroup) {
                            return QuestionnaireGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('questionnaire-group', null, { reload: 'questionnaire-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
